<template>
  <NuxtLayout>
    <div class="ThePoliciesPage">
      <section>
        <h1 class="ThePoliciesPage_Title">Table of Contents:</h1>
        <ul class="ThePoliciesPage_TOC">
          <li>
            <SkyLink to="#privacy-policy">Privacy Policy</SkyLink>
          </li>
          <li>
            <SkyLink to="#terms-of-use">Terms of Use</SkyLink>
          </li>
          <li>
            <SkyLink to="#referral-policy">Referral Policy</SkyLink>
          </li>
          <li>
            <SkyLink to="#accessibility-policy">
              Accessibility (ADA) Policy
            </SkyLink>
          </li>
          <li>
            <SkyLink to="#cookie-policy">Cookie Policy</SkyLink>
          </li>
          <li>
            <SkyLink to="#refund-policy">Refund Policy</SkyLink>
          </li>
        </ul>
      </section>

      <PoliciesThePrivacyPolicy id="privacy-policy" />
      <PoliciesTheTermsOfUse id="terms-of-use" />
      <PoliciesTheReferralPolicy id="referral-policy" />
      <PoliciesTheAccessibilityPolicy id="accessibility-policy" />
      <PoliciesTheCookiePolicy id="cookie-policy" />
      <PoliciesTheReturnPolicy id="refund-policy" />
      <PoliciesTheTrademarks id="trademarks" />

      <section>
        <p>
          <b>Our contact information:</b><br />
          Grove Collaborative, Inc.<br />
          1301 Sansome Street<br />
          San Francisco, CA 94111
        </p>
      </section>
    </div>
  </NuxtLayout>
</template>
<script setup lang="ts">
/**
 * Policies Page
 * This page is responsible for rendering all of Grove's policies.
 */

// Set the page meta data
definePageMeta({
  showNotificationBar: false,
  showFabModal: false,
})

// Set the page title
useHead({
  title: 'Policies',
})
</script>
<style lang="scss">
.ThePoliciesPage {
  display: grid;
  row-gap: var(--spacing-4x);

  &_Title {
    @include type-brand-heading('1');
    text-align: center;
    margin-bottom: var(--spacing-1x);
  }

  &_TOC {
    text-align: center;
    list-style: none;
    margin: 0;
    margin-bottom: var(--spacing-1x);
  }
}
</style>
